import CryptoJS from 'crypto-js';

const decryptData = (payload, key) => {
  try {
    const decodedPayload = atob(payload); // base64-decode whole thing
    const { data, iv } = JSON.parse(decodedPayload);

    const encryptedData = CryptoJS.enc.Base64.parse(data);
    const ivWordArray = CryptoJS.enc.Base64.parse(iv);
    const keyHash = CryptoJS.SHA256(key); // ✔️ matches PHP hash('sha256', $key, true)

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      keyHash,
      {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    console.log('decrypted orih===============================:', decrypted);
    const result = decrypted.toString(CryptoJS.enc.Utf8);
    console.log('decrypted===============================:', result);
    return result || null;
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};
export default decryptData;
